<template>
  <div class="home_solve">
    <div class="init">
      <div class="title">/ 解决方案 /</div>
      <div class="title2">专业、专一、行业全领域覆盖</div>
      <div class="cont">
        <div class="item" v-for="(item, index) in solveList" :key="index">
          <div class="item_init">
            <div class="icon" :class="item.icon"></div>
            <div class="right">
              <div class="title3">
                <span>{{ item.title }}</span>
                <icon name="caret-down" width="16" />
              </div>
              <div class="text">
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      solveList: [
        {
          title: '电子账户',
          icon: "icon3",
          desc: '涉及进行会员、账户进行管理的应用场景都需要有电子账户进行支撑。部分第三方支付公司和金融机构对互金企业提供账户体系输出。'
        },
        {
          title: '聚合支付',
          icon: "icon5",
          desc: '金融业务应用中，往往涉及资金支付需求。整个支付生态链由消费场景、第三方支付公司、银行结算账户、人行清算系统组成，我们侧重在消费场景聚合支付及第三方支付公司系统架构上。'
        },
        {
          title: '征信金融',
          icon: "icon4",
          desc: '金融的核心是信用定价。互联网金融一般采用人员细分、服务场景化，以及通过对第三方征信的聚合进行有效风险管理。'
        },
        {
          title: '消费金融',
          icon: "icon1",
          desc: '消费金融以消费场景为切入口，通过分期、白条等方式提供金融服务，可以有效促进消费，并产生金融利差利润。'
        },
        {
          title: '融资租债',
          icon: "icon6",
          desc: '融资租赁将成为“仅次于银行信贷的第二大融资方式”。汽车融资租赁业务是汽车金融很重要一环，也是网络借贷中优质资产的提供方。'
        },
        {
          title: '大数据',
          icon: "icon2",
          desc: '多家行业头部企业和政府客户，提供了数据中台建设和数据资产开发服务。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.home_solve {
  width: 100%;
  padding: 0.5rem 0;
  background-color: #F6F7FB;
}

.init {
  width: 82%;
  margin: 0 auto;
  max-width: 1196px;
}


.title {
  color: #073875;
  line-height: 0.48rem;
  font-size: 0.48rem;
  text-align: center;
}

.title2 {
  margin-top: 0.15rem;
  color: #333;
  line-height: 0.18rem;
  font-size: 0.18rem;
  text-align: center;
}

.cont {
  width: 100%;
  margin-top: 0.5rem;
  overflow: hidden;
}

.item {
  width: 50%;
  float: left;
}

.item_init {
  height: 3rem;
  margin: 0.1rem;
  font-size: 0.15rem;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  box-shadow: 3px 3px 6px -4px rgb(0 0 0 / 15%);
}

.item_init:hover,
.item_init:active {
  background-image: url(../../assets/images/home/solvesel2.png);
  background-size: cover;
}

.icon {
  width: 30%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}

.right {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title3 {
  line-height: 0.2rem;
  margin-right: 10%;
  padding: 0.2rem 0;
  font-size: 0.2rem;
  font-weight: 600;
  border-bottom: 1px solid #F1F0F0;
}

.title3 span {
  margin-right: 5px;
}

.text {
  margin: 0.1rem 10% 0 0;
  line-height: 0.3rem;
  font-size: 0.15rem;
  color: #666;
}
.item_init:hover .title3,
.item_init:active .title3,
.item_init:hover .icon,
.item_init:active .icon,
.item_init:hover .text,
.item_init:active .text {
  color: #fff;
  fill:#fff;
}

.item .icon1 {
  background-image: url(../../assets/images/home/icon1.png);
}

.item:hover .icon1 {
  background-image: url(../../assets/images/home/icon1h.png);
}

.item .icon2 {
  background-image: url(../../assets/images/home/icon2.png);
}

.item:hover .icon2 {
  background-image: url(../../assets/images/home/icon2h.png);
}

.item .icon3 {
  background-image: url(../../assets/images/home/icon3.png);
}

.item:hover .icon3 {
  background-image: url(../../assets/images/home/icon3h.png);
}

.item .icon4 {
  background-image: url(../../assets/images/home/icon4.png);
}

.item:hover .icon4 {
  background-image: url(../../assets/images/home/icon4h.png);
}

.item .icon5 {
  background-image: url(../../assets/images/home/icon5.png);
}

.item:hover .icon5 {
  background-image: url(../../assets/images/home/icon5h.png);
}

.item .icon6 {
  background-image: url(../../assets/images/home/icon6.png);
}

.item:hover .icon6 {
  background-image: url(../../assets/images/home/icon6h.png);
}

@media screen and (max-width: 768px) {
  .title {
    line-height: 0.8rem;
    font-size: 0.8rem;
  }

  .title2 {
    margin-top: 0.3rem;
    line-height: 0.4rem;
    font-size: 0.4rem;
  }

  .item {
    width: 100%;
  }

  .item_init {
    height: 6rem;
    margin: 0.2rem;
    font-size: 0.15rem;
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    box-shadow: 3px 3px 6px -4px rgb(0 0 0 / 15%);
  }

  .icon {
    background-size: 1rem;
  }

  .title3 {
    line-height: 0.9rem;
    font-size: 0.45rem;
  }

  .text {
    margin-top: 0.4rem;
    line-height: 0.5rem;
    font-size: 0.35rem;
  }
}
@media screen and (max-width: 500px) {
  .title {
    line-height: 0.6rem;
    font-size: 0.6rem;
  }
}
</style>